import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import Example from './example'
import AddExample from './addexample'
import { connect } from 'react-redux'
import { changeRule, deleteRule, saveRule, selectRule, deselectRule } from '../../actioncreators/actioncreators'
import swal from 'sweetalert'
import truncate from 'truncate'
const { Component } = React

const preventPropagation = (e) => {
  e.stopPropagation()
}

export class Rule extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      hover: false
    }

    this.ruleInput = React.createRef()
    this.examplesRef = React.createRef()
    this.examplesCollapseIndicatorRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.allowAutofocus) {
      this.ruleInput.current.focus()
    }
  }

  render () {
    let examples = this.props.rule.examples.map((example) => {
      return (<Example example={example} key={example.id} />)
    })
    return (
      <Draggable
        draggableId={'rule-draggable-' + this.props.rule.id.toString()}
        index={this.props.index}
        type='rule'>
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            onDoubleClick={preventPropagation}
          >
            <div
              style={{
                minWidth: 290,
                maxWidth: 290,
                display: 'flex',
                flexDirection: 'column',
                marginRight: 5
              }}
            >
              <div className='text-center' style={{ display: this.props.splittingMode ? 'block' : 'none', marginBottom: 5 }}>
                <button className='btn btn-default btn-sm' style={{ display: this.props.rule.selected ? 'none' : 'inline' }} onClick={this.props.selectRule} title='Select this rule and example'>
                  Unselected
                </button>
                <button className='btn btn-success btn-sm' style={{ display: this.props.rule.selected ? 'inline' : 'none' }} onClick={this.props.deselectRule} title='Select this rule and example'>
                  Selected
                </button>
              </div>
              <div className='panel panel-default' style={{ backgroundColor: '#f7f7f7', marginLeft: 3, marginRight: 3, border: 'none', boxShadow: '1px 1px 5px 0px rgba(9,30,66,0.25)' }}>
                <div {...provided.dragHandleProps}
                    onMouseDown={(e) => {
                        if (e.target.nodeName === 'SPAN' || e.target.nodeName === 'BUTTON' || e.target.nodeName === 'TEXTAREA') return
                        this.examplesRef.current.style.display = 'none'
                        this.examplesCollapseIndicatorRef.current.style.display = 'block'
                        provided.dragHandleProps.onMouseDown(e)
                      }
                    }
                    onMouseUp={() => {
                        this.examplesRef.current.style.display = 'block'
                        this.examplesCollapseIndicatorRef.current.style.display = 'none'
                      }
                    } style={{ display: 'flex', padding: 7 }}>
                  <div style={{ backgroundColor: '#0C8CE6', width: 7, margin: '0px 7px 0px 0px' }}>&nbsp;</div>
                  <div className='panel-body' style={{ padding: 0, flexGrow: 1 }}
                    onMouseEnter={() => this.setState({ hover: true })}
                    onMouseLeave={() => this.setState({ hover: false })}>
                    <button className={this.state.hover ? 'btn btn-default btn-xs' : 'hidden btn btn-default btn-xs'}
                      style={{ position: 'absolute', marginTop: -5, marginLeft: 237, zIndex: '100' }}
                      onClick={this.props.deleteRule}
                      title='Delete rule'>
                      <span className='glyphicon glyphicon-trash' aria-hidden='true' />
                    </button>
                    <textarea
                      className='form-control'
                      rows='4'
                      value={this.props.rule.text}
                      onChange={this.props.onChange}
                      onBlur={this.props.saveRule}
                      placeholder='Enter a rule which captures a behaviour of your story'
                      style={{ resize: 'vertical', padding: 6 }}
                      ref={this.ruleInput}
                    />
                  </div>
                </div>
                <div className='exampleCollapseIndicator' ref={this.examplesCollapseIndicatorRef} style={{ textAlign: 'center', fontSize: 11, marginBottom: 10, display: 'none' }}>examples collapsed</div>
                <ul className='list-group collapsibleExamples' ref={this.examplesRef}>
                  {examples}
                </ul>
                <div className='panel-footer' style={{ padding: '0px 4px 4px 4px', backgroundColor: 'inherit', border: 'none' }}>
                  <div className='text-center'>
                    <AddExample rule={this.props.rule.id} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    rule: ownProps.rule,
    index: ownProps.index,
    allowAutofocus: store.exampleMap.allowAutofocus,
    splittingMode: store.exampleMap.splittingMode
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    onChange: function (event) {
      dispatch(changeRule(ownProps.rule.id, event.target.value))
    },
    deleteRule: function () {
      let foundANonEmptyExample = false
      console.log('examples', ownProps.rule.examples)
      for(const example of ownProps.rule.examples) {
        if (example.text.length !== 0) {
          foundANonEmptyExample = true
          break
        }
      }
      const canInstaDelete = ownProps.rule.text.length === 0 & (ownProps.rule.examples.length === 0 || !foundANonEmptyExample)
      if(canInstaDelete) {
        dispatch(deleteRule(ownProps.rule.id))
        return
      }
      swal({
        title: 'Delete this rule?',
        text: `Click OK to delete "${truncate(ownProps.rule.text, 30)}"`,
        icon: 'warning',
        buttons: true
      })
        .then((willDelete) => {
          if (willDelete) {
            dispatch(deleteRule(ownProps.rule.id))
          }
        })
    },
    saveRule: function () {
      dispatch(saveRule())
    },
    selectRule: function () {
      dispatch(selectRule(ownProps.rule.id))
    },
    deselectRule: function () {
      dispatch(deselectRule(ownProps.rule.id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rule)
